import React from "react";
import {
    Button,
    Disclosure,
    DisclosureGroup,
    DisclosurePanel,
    Heading,
} from "react-aria-components";

import { FaqBlock, FaqEntry } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { RichText } from "../RichText";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

function Entry({ value, id }: { value: FaqEntry; id: string }) {
    return (
        <Disclosure id={id}>
            <Heading>
                <Button className={styles.button} slot="trigger">
                    <span>{value.question}</span>
                    <Svg name="plus" />
                </Button>
            </Heading>
            {value.answer && (
                <DisclosurePanel className={styles.panel}>
                    <RichText value={value.answer} />
                </DisclosurePanel>
            )}
        </Disclosure>
    );
}

export function Faq({ value }: { value: FaqBlock }) {
    return (
        <section
            className={concatClassNames([
                styles.root,
                value.background == "gradient" ? styles.gradient : undefined,
            ])}
        >
            <div className={styles.header}>{value.header}</div>
            <DisclosureGroup>
                {value.entries?.map(({ value: entry, id }) => (
                    <Entry key={id} id={id} value={entry} />
                ))}
            </DisclosureGroup>
        </section>
    );
}
